import { Layout, Spin } from 'antd'
import React from 'react'
import AdminAppointmentCardTabs from './AdminAppointmentCardTabs'
import AdminAppointmentActions from './AdminAppointmentActions'

export default function AdminAppointmentCard ({ form, appointment, setAppointment, loading, setLoading, cancel, back, delay, setIsDirty }) {
  return (
    <Layout style={{ backgroundColor: 'white', padding: '1em 0', fontSize: '24px' }}>
      <Spin spinning={loading}>
        <AdminAppointmentCardTabs form={form} appointment={appointment} setAppointment={setAppointment} loading={loading} setLoading={setLoading} setIsDirty={setIsDirty} />
        <AdminAppointmentActions form={form} appointment={appointment} cancel={cancel} back={back} delay={delay} />
      </Spin>
    </Layout>
  )
}
